export default "__VITE_ASSET__DVMdOlay__"